export default __webpack_public_path__ + "static/media/ic-search.ce684feb.svg";